module.exports = __webpack_public_path__ + "static/media/11.40c6777d.png";